/**
 * Askable connector — single source of truth for all Askable metadata.
 *
 * SVG: Askable's logo is hosted on their Webflow CDN with hotlink protection.
 * To add the real logo: download the SVG from https://www.askable.com (check
 * page source for the CDN asset URL), extract the path d value, and set it here.
 * Brand color confirmed from askable.com CSS: #6941C6.
 */

module.exports = {
  id:          'askable',
  name:        'Askable',
  enabled:     false,
  iconBg:      '#6941C6',
  svgPath:     null, // TODO: source from Askable brand kit

  tagline:     'Pull participant research and session insights into agent context.',
  description: 'Connect Askable so agents can read moderated research findings, participant quotes, and study insights when reasoning about your users and their unmet needs.',
  useCases: [
    'Surface participant findings when agents assess user problems',
    'Pull study insights into opportunity framing and brief generation',
    'Ground strategy in moderated research evidence',
  ],
};
